// -- copyright
// OpenProject Documents Plugin
//
// Former OpenProject Core functionality extracted into a plugin.
//
// Copyright (C) 2009-2014 the OpenProject Foundation (OPF)
//
// This program is free software; you can redistribute it and/or
// modify it under the terms of the GNU General Public License version 3.
//
// OpenProject is a fork of ChiliProject, which is a fork of Redmine. The copyright follows:
//   # Copyright (C) 2006-2013 Jean-Philippe Lang
// Copyright (C) 2010-2013 the ChiliProject Team
//
// This program is free software; you can redistribute it and/or
// modify it under the terms of the GNU General Public License
// as published by the Free Software Foundation; either version 2
// of the License, or (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program; if not, write to the Free Software
// Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
//
// See docs/COPYRIGHT.rdoc for more details.
// ++

import {APP_INITIALIZER, Injector, NgModule} from '@angular/core';
import {OpenProjectPluginContext} from "core-app/modules/plugins/plugin-context";
import {DocumentResource} from './hal/resources/document-resource';
import {multiInput} from 'reactivestates';

export function initializeDocumentPlugin() {
    return () => {
        window.OpenProject.getPluginContext()
            .then((pluginContext:OpenProjectPluginContext) => {
                let halResourceService = pluginContext.services.halResource;
                halResourceService.registerResource('Document', { cls: DocumentResource });

                let states = pluginContext.services.states;
                states.add('documents', multiInput<DocumentResource>());
            });
    };
}


@NgModule({
    providers: [
        { provide: APP_INITIALIZER, useFactory: initializeDocumentPlugin, deps: [Injector], multi: true },
    ],
})
export class PluginModule {
}
